<div class="alert alert-danger alertMessageStyles80" role="alert" *ngIf="displayFailure">
    <h5 class="H5Normal" style="display:inline">{{this.failureText}}</h5>
    <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideFailureAlert()">X</h5>
</div>
<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight4" style="background-size: cover; background-position:center; "
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
        <div class="row">
            <div style="width:10%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">FIND
                    YOUR REP
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">YOUR
                    PARTNER FOR SUCCESS</h1>
                <div style="width:10%"></div>
            </div>
        </div>
    </div>

    <div class="blueBackground" style="padding-bottom:70px">
        <div class="row" style="width:80%; max-width:1500px; margin:auto; padding-top:70px">
            <h2 class="CaeciliaRegular whiteText"
                style="padding-left:0px; font-size: 28px;font-style: normal; font-weight: 700; line-height: normal;">
                Find Your Rep</h2>
        </div>

        <div class="row" style="width:80%; max-width:1500px; margin:auto">
            <div class="row d-block">
                <select class="DIN2014Regular"
                    style="font-size: 16px;line-height: 30px; width: 332px;border: 1px solid rgba(255, 255, 255, 0.10);background: #378aaa;backdrop-filter: blur(2.5px);padding: 12px 14px 12px 14px;color: white;"
                    [(ngModel)]="this.selectedMarket" (ngModelChange)="MarketRadioChanged($event)">
                    <option class="DIN2014"
                        style="font-size: 16px;line-height: 30px;width: 332px;border: 1px solid rgba(255, 255, 255, 0.10);background-color: #378aaa;backdrop-filter: blur(2.5px);padding: 12px 14px 12px 14px;color: white;;"
                        value="">
                        Select Your Market</option>

                    <option *ngFor="let row of this.allSegments" class="DIN2014Regular"
                        style="font-size: 16px;line-height: 30px;width: 332px;border: 1px solid rgba(255, 255, 255, 0.10);background-color: #378aaa;backdrop-filter: blur(2.5px);padding: 12px 14px 12px 14px;color: white;"
                        value="{{row.WebSegment}}">
                        {{row.WebSegment}}</option>
                </select>

                <input Class="DIN2014Regular whitePlaceholderNoOpcity"
                    style="height:48px;margin-left:15px; display:inline;font-size: 16px;line-height: 30px;width: 332px;border: 1px solid rgba(255, 255, 255, 0.10);background-color: #378aaa;backdrop-filter: blur(2.5px);padding: 12px 14px 12px 14px;color: white;"
                    placeholder="Enter Your Zip Code" [(ngModel)]="this.zipCode" (keyup.enter)="GetRepsFromZip()">
                <a class="submitButtonTopMobile"
                    style="padding:15px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                    (click)="GetRepsFromZip()">
                    <h3 class="DINNextLTPro-Black blueText lightBlueBackground"
                        style="display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">SUBMIT</h3>
                </a>
            </div>

        </div>
    </div>

    <!-- grid of reps  -->
    <div class="row whiteBackground blackText gridOfRepsContainer">

        <div class="row text-align-start" style="text-align: left; padding-left:40px; padding-right:70px">
            <h3 class="Caecilia76BoldItalic greenText"
                style="width:70%; display:inline; font-size:28px; font-weight: 700; margin-bottom:40px; ">
                Browse Our Directory</h3>
            <a *ngIf="(this.myHarrellsService.bootstrapViewPortSize && !(this.myHarrellsService.bootstrapViewPortSize== 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'))"
                style="width:30%; float:right;display:inline;">
                <h3 class="Caecilia76BoldItalic blackText" (click)="GetAllReps()"
                    style="cursor:pointer;float:right;display:inline; font-size:16px; font-weight: 700; margin-top:10px; text-decoration: underline; ">
                    VIEW ALL REPS</h3>
            </a>
        </div>

        <!-- <img *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
        src="{{baseImagePaths + 'FilterIconDark.png'}}"
        style="cursor:pointer; width:60px; height:40px; position:absolute; right:10px" alt="filter icon"
        (click)="ToggleFilter()"> -->

        <div class="row d-block sortDropdown" style="margin-bottom:32px; padding-left:50px">
            <input Class="DIN2014Regular"
                style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px;padding:14px"
                placeholder="Search Reps" (keyup)="FilterRepsFired()" [(ngModel)]="this.repSearchText">
            <img src="{{this.baseImagePaths + 'SearchIcon.jpg'}}" alt="Search Icon"
                style="display:inline;height:20px;width:50px;margin-left:-50px">
            <!-- <select class="DIN2014Regular" style="font-size:19px;line-height:30px;height:48px;width:254px"
                [(ngModel)]="this.selectedSort" (ngModelChange)="MarketSortChanged()">
                <option class="DIN2014Regular" style="font-size:19px; line-height: 30px; font-weight:400" value="">
                    SORT BY: Market</option>

                <option *ngFor="let row of this.allSegments" class="DIN2014Regular"
                    style="font-size:19px; line-height: 30px; font-weight:400" value="{{row.WebSegment}}">
                    {{row.WebSegment}}</option>
            </select> -->
            <img *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                src="{{baseImagePaths + 'FilterIconDark.png'}}"
                style="cursor:pointer; width:60px; height:40px; position:absolute; right:10px" alt="filter icon"
                (click)="ToggleFilter()">

        </div>
        <div *ngIf="( this.myHarrellsService.bootstrapViewPortSize && !(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'))
        || ((this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm') && showFilterObjects)"
            class="filterContainerProperties">
            <h4 class="DIN2014Bold"
                style="text-decoration: underline; font-size:26px; font-size:700; text-align: left; text-decoration: none;">
                Filters</h4>
            <h4 *ngIf="((this.myHarrellsService.bootstrapViewPortSize== 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'))"
                class="DIN2014Bold" (click)="GetAllReps()"
                style="width:90VW; font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; ">
                ALL</h4>
            <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('Market')"
                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left;">
                MARKET
                <!-- <img *ngIf="!marketExpanded" src="{{this.baseImagePaths + 'plus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px; margin-right:25%;">
                <img *ngIf="marketExpanded" src="{{this.baseImagePaths + 'minus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px; margin-right:25%;"> -->
            </h4>
            <!-- <div *ngIf="marketExpanded"> -->
                <div style="margin-bottom:14px">
                    <div *ngFor="let row of this.allSegments" style="text-align: left;">
                        <input type="radio" name="marketRadios" class="marketsCheckbox radio-nipple" id="{{row.WebSegment}}"
                            (change)="MarketRadioChanged(row.WebSegment)">
                        <h6 class="DIN2014Regular"
                            style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; margin-bottom:0; margin-left:5px">
                            {{row.WebSegment}}</h6>
                    </div>
                </div>
            <!-- </div> -->
            <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('State')"
                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left">
                STATES
            </h4>
            <div>
                <select class="DIN2014Regular" style="display:inline;font-size:19px;line-height:20px;letter-spacing: .28px; gap:10px; align-items: center;height:44px; width:254px; padding-left:10px;
                    align-items: center; gap: 10px; backdrop-filter: blur(2.5px);margin-bottom:15px"
                    [(ngModel)]="this.selectedState" (ngModelChange)="StateChanged($event)">
                    <option class="DIN2014Regular" style="font-size:19px; line-height: 30px; font-weight:400" value="">
                        Select Your State</option>

                    <option *ngFor="let row of this.allStates" class="DIN2014Regular" value="{{row.state}}">
                        {{row.name}}</option>
                </select>
            </div>


        </div>
        <div id='jumpToAnchorReps' class="rightPanelRepsGrid">
            <div class="row" style="text-align:left">
                <div class="col-lg-4" *ngFor="let rep of this.repsFilteredList" style="margin-bottom:3%">
                    <div (click)="GoToRepDetail(rep)" style="cursor: pointer;" *ngIf="rep && rep.Id > 0">
                        <img class="repImage" src={{rep.empPhoto}} alt="emp image" [id]="rep.Id">
                        <h5 class="DIN2014Regular"
                            style="text-transform:capitalize; font-size:19px; line-height: 19.2px; font-weight:700;letter-spacing: .38px; padding-top:10px">
                            {{rep.FirstName}} {{rep.LastName}}</h5>
                        <h5 class="DIN2014Regular"
                            style="overflow:hidden; min-height:37px; max-height:37px; height:37px; text-transform:capitalize; font-size:15px; line-height: 19.2px; font-weight:400;letter-spacing: .3px;">
                            {{rep.Title}}</h5>
                        <h5 class="DIN2014Regular"
                            style="text-transform:uppercase; font-size:16px; line-height: 19px; font-weight:700; line-height:19px; letter-spacing: .3px">
                            <a href='tel:{{rep.phone}}' style="color:black">{{rep.phone | phoneNumber }}</a>
                        </h5>
                        <h5 class="DIN2014Regular"
                            style="font-size:16px; line-height: 19px; font-weight:700; line-height:19px; letter-spacing: .32px">
                            {{rep.email}}</h5>
                        <h5 class="DIN2014Regular"
                            style="min-height:20px;text-transform:capitalize; font-size:14px; line-height: 19px; letter-spacing: .28px; font-weight:400;">
                            {{rep.Twitter}}</h5>
                        <h5 class="DIN2014Regular" *ngFor=" let market of rep.MarketArray"
                            style="display:inline-block; text-transform:capitalize; font-size:16px; line-height: 20px; letter-spacing: .32px; font-weight:600;background: rgba(2, 125, 60, 0.10); color:#027D3C; padding: 7px 12px; margin-right:12px">
                            {{market | uppercase}}</h5>
                    </div>
                </div>
                <div class="row moreButtonRow">
                    <!-- [disabled]="this.dotComService.products.length >= this.dotComService.productsMasterList.length"
                    [ngClass]="{'grayOut': this.dotComService.products.length >= this.dotComService.productsMasterList.length}" -->
                    <!-- <button *ngIf="this.EOPMode == false" -->
                    <button *ngIf="displayMoreButton"
                        style="height:38px; width:131px;border:none; margin-top:5%; font-size:20px; line-height: 27px; font-weight:700;"
                        class="DINNextLTPro-Black greenBackground whiteText" (click)="LoadMoreReps()">Load More
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="blueBackground">
        <div class="row" style="width:80%; max-width:1500px; margin:auto; padding-top:70px">
            <h2 class="Caecilia76BoldItalic  whiteText"
                style="text-align: center;font-size: 28px;font-style: normal; font-weight: 700; line-height: normal;">
                Let Us Help Match You With Your Rep</h2>
        </div>
        <div class="row" style="width:80%; max-width:1500px; margin:auto;padding-bottom:32px">
            <h2 class="Caecilia76BoldItalic  whiteText"
                style="text-align: center;font-size: 16px; line-height: 22px; font-weight: 700; color:#FFFFFC; opacity: 55%">
                Complete The Form Below to Be Connected with Your Local Harrell’s Rep</h2>
            <!-- <h2 class="Caecilia76BoldItalic  whiteText"
            style="text-align: center;font-size: 16px; line-height: 22px; font-weight: 700; color:#FFFFFC; opacity: 55%">
            Find The Right Harrell's Rep For You</h2> -->
        </div>
    </div>
    <div class="blueBackground">
        <div class="row letUsFormContainer">
            <!-- <div id="hubspotFindRepForm" style="width:430px; margin:auto; color:white">hubspot form here</div> -->
            <div class="row" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="First Name*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.firstNameRepMatch">
                <input type="text" placeholder="Last Name*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.lastNameRepMatch">
            </div>
            <div class="row" style="margin:auto;padding-bottom:26px">
                <input type="text" placeholder="Company Name*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.companyRepMatch">
                <input type="text" placeholder="Job Title*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.titleRepMatch">
            </div>
            <div class="row" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="Phone Number*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular "
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.phoneRepMatch">
                <input type="text" placeholder="Email*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.emailRepMatch">
            </div>
            <div class="row" style="margin:auto;padding-bottom:26px">
                <input type="text" placeholder="City*" class="whitePlaceholder blueBackground whiteText Din2014Regular"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.cityRepMatch">
                <input type="text" placeholder="State*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.stateRepMatch">
            </div>
            <div class="row" style="margin:auto;padding-bottom:26px">
                <input type="text" placeholder="Zip*" class="whitePlaceholder blueBackground whiteText Din2014Regular"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.zipRepMatch">
                <!-- <input type="text" placeholder="State*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.stateRepMatch"> -->
            </div>

            <h4 class="Din2014Regular whiteText"
                style="margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Choose
                Your Market(s)*</h4>

            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="golfRepMatch"
                    (change)="golfRepMatch = !golfRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Golf</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="horticultureRepMatch"
                    (change)="horticultureRepMatch = !horticultureRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Horticulture</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="sportsTurfRepMatch"
                    (change)="sportsTurfRepMatch = !sportsTurfRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Sports Turf</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="specialtyAgRepMatch"
                    (change)="specialtyAgRepMatch = !specialtyAgRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Specialty Ag</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="lawnCareRepMatch"
                    (change)="lawnCareRepMatch = !lawnCareRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Lawn Care</h4>
            </div>

            <textarea class="whitePlaceholder blueBackground whiteText DIN2014Regular textareaCanWeHelpMobile"
                [(ngModel)]="this.commentsRepMatch" style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; 
            margin-left:10px; letter-spacing:.38px; font-weight:400; 
            border: 1px solid #FFF;width:820px; height:100px;margin-right:10px"
                placeholder="How Can We Help?"></textarea>
            <div class="row whiteBackground"
                style="margin-top:26px; text-align: center;width:auto; margin-left:10px; padding:0px">
                <button class="DINNextLTPro-Black blueText"
                    [disabled]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == '' || this.zipRepMatch == '' || this.titleRepMatch == ''"
                    [ngClass]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == '' || this.zipRepMatch == '' || this.titleRepMatch == '' ? 'greyDisabled':'' "
                    style="padding:10px 10px 7px 10px;font-size:20px; font-weight: 900; line-height:normal; text-decoration: none !important"
                    (click)="sendEmail()">SUBMIT YOUR REQUEST</button>
            </div>

        </div>
    </div>